<div class="container-fluid">
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">

      <ng-container *ngIf="!isLoading">
        <div *ngIf="remark" class="card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <fa-icon [icon]="['fas', 'file-invoice']" size="lg" class="me-2" [fixedWidth]="true">
              </fa-icon>
              {{ 'label.remark' | translate }}
            </div>
            <button type="button" class="btn btn-sm btn-blue text-bold" (click)="navigateBack()">
              {{ 'button.back' | translate }}
            </button>
          </div>

          <div class="card-body">
            <creditor-remark [caseId]="caseId" [remark]="remark" [creditorId]="creditorId"></creditor-remark>
          </div>
        </div>
      </ng-container>

      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <fa-icon [icon]="['fas', 'file-invoice']" size="lg" class="me-2" [fixedWidth]="true">
            </fa-icon>

            {{ titleKey | translate }}
          </div>

          <div class="card-header-actions">
            <button
              *ngIf="isReadOnly && claimId"
              type="button"
              class="btn-kvittens"
              [class.btn-kvittens--loading]="isDownloadingReceipt"
              [disabled]="isDownloadingReceipt || isLoading"
              (click)="downloadReceipt()">
              <fa-icon [icon]="['fas', isDownloadingReceipt ? 'circle-notch' : 'file-pdf']" [animation]="isDownloadingReceipt ? 'spin' : undefined" [size]="'lg'" class="me-1" [fixedWidth]="true"></fa-icon>
              {{ (isDownloadingReceipt ? 'button.downloading-receipt' : 'button.download-receipt') | translate }}
            </button>
            <button *ngIf="!remark" type="button" class="btn btn-sm btn-blue text-bold" (click)="navigateBack()">
              {{ 'button.back' | translate }}
            </button>
          </div>
        </div>

        <div class="card-body">

          <div
            *ngIf="!isLoading && formBanner as banner"
            class="process-banner mb-4"
            [ngClass]="{
              'process-banner--info': banner.variant === 'info',
              'process-banner--success': banner.variant === 'success',
              'process-banner--warning': banner.variant === 'warning',
              'process-banner--danger': banner.variant === 'danger'
            }">
            <div class="process-banner__title">{{ banner.title }}</div>
            <div class="process-banner__text">{{ banner.text }}</div>
          </div>

          <ng-container *ngIf="isLoading; else loadedForm">
            <div class="form-section">
              <div class="skeleton skeleton-section-title mb-4"></div>

              <div class="form-grid">
                <div class="form-field" *ngFor="let _ of [1,2,3,4,5,6,7,8]">
                  <div class="skeleton skeleton-label mb-2"></div>
                  <div class="skeleton skeleton-input"></div>
                </div>
              </div>

              <div class="form-field mt-3">
                <div class="skeleton skeleton-label mb-2"></div>
                <div class="skeleton skeleton-textarea"></div>
              </div>
            </div>

            <div class="form-section">
              <div class="skeleton skeleton-section-title mb-4"></div>

              <div class="form-grid">
                <div class="form-field" *ngFor="let _ of [1,2,3,4,5,6,7,8,9,10]">
                  <div class="skeleton skeleton-label mb-2"></div>
                  <div class="skeleton skeleton-input"></div>
                </div>
              </div>
            </div>

            <div class="form-section">
              <div class="skeleton skeleton-section-title mb-4"></div>

              <div class="form-grid">
                <div class="form-field" *ngFor="let _ of [1,2,3,4,5,6]">
                  <div class="skeleton skeleton-label mb-2"></div>
                  <div class="skeleton skeleton-input"></div>
                </div>
              </div>
            </div>

            <div class="form-actions mt-4">
              <div class="skeleton skeleton-button"></div>
            </div>
          </ng-container>

          <ng-template #loadedForm>
            <form [formGroup]="form" novalidate>

              <div class="form-section">
                <div class="section-title">
                  {{ 'label.creditor-and-claim' | translate }}
                </div>
                <div class="section-subtitle mb-3">
                  {{ 'label.section-description-claim' | translate }}
                </div>

                <div class="form-grid">
                  <div class="form-field">
                    <label for="creditorName">
                      {{ 'label.creditor' | translate }}
                      <app-field-help [tooltip]="'help.creditor-name' | translate"></app-field-help>
                    </label>
                    <input id="creditorName" type="text" class="form-control" formControlName="creditorName" [placeholder]="'placeholder.example-creditor-name' | translate" [readonly]="isReadOnly">

                    <small class="text-danger" *ngIf="hasError('creditorName', 'required')">
                      {{ 'validation.creditor-required' | translate }}
                    </small>

                    <small class="text-danger" *ngIf="hasError('creditorName', 'debtorNotAllowedAsCreditor')">
                      {{ 'validation.debtor-not-allowed-as-creditor' | translate }}
                    </small>
                  </div>

                  <div class="form-field">
                    <label for="creditorOrgOrPersNr">
                      {{ 'label.org-or-personal-number' | translate }}
                      <app-field-help [tooltip]="'help.org-or-personal-number' | translate"></app-field-help>
                    </label>
                    <input id="creditorOrgOrPersNr" type="text" class="form-control" formControlName="creditorOrgOrPersNr" [placeholder]="creditorOrgOrPersNrPlaceholder" [readonly]="isReadOnly">

                    <small class="text-danger" *ngIf="hasError('creditorOrgOrPersNr', 'required')">
                      {{ 'validation.org-or-personal-number-required' | translate }}
                    </small>

                    <small class="text-danger" *ngIf="hasError('creditorOrgOrPersNr', 'invalidOrgOrPersonalNumber')">
                      {{ 'validation.org-or-personal-number-invalid' | translate }}
                    </small>

                    <small class="text-danger" *ngIf="hasError('creditorOrgOrPersNr', 'debtorNotAllowedAsCreditor')">
                      {{ 'validation.debtor-not-allowed-as-creditor' | translate }}
                    </small>

                    <div class="form-check mt-1">
                      <input type="checkbox" class="form-check-input" id="isNotSwedish" formControlName="isNotSwedish" [attr.disabled]="isReadOnly ? true : null">
                      <label class="form-check-label" for="isNotSwedish">
                        {{ 'label.is-not-swedish' | translate }}
                      </label>
                    </div>
                  </div>

                  <div class="form-field">
                    <label>
                      {{ 'label.creditor-type' | translate }}
                      <app-field-help [tooltip]="'help.creditor-type' | translate"></app-field-help>
                    </label>

                    <select class="form-control" formControlName="creditorType" [disabled]="isReadOnly">
                      <option *ngFor="let type of creditorTypes" [ngValue]="type">
                        {{ type | creditorTypeLabel }}
                      </option>
                    </select>

                    <small class="text-danger" *ngIf="hasError('creditorType', 'required')">
                      {{ 'validation.creditor-type-required' | translate }}
                    </small>
                  </div>

                  <div class="form-field">
                    <label>
                      {{ 'label.claim-type' | translate }}
                      <app-field-help [tooltip]="'help.claim-type' | translate"></app-field-help>
                    </label>

                    <select class="form-control" formControlName="claimType" [disabled]="isReadOnly">
                      <option *ngFor="let type of claimTypes" [ngValue]="type">
                        {{ type | claimTypeLabel }}
                      </option>
                    </select>

                    <small class="text-danger" *ngIf="hasError('claimType', 'required')">
                      {{ 'validation.claim-type-required' | translate }}
                    </small>
                  </div>

                  <div class="form-field">
                    <label for="claimAmount">
                      {{ 'label.amount' | translate }}
                      <app-field-help [tooltip]="'help.amount' | translate"></app-field-help>
                    </label>
                    <app-decimal-input formControlName="amount" inputId="claimAmount" [placeholder]="'placeholder.example-amount' | translate" [readonly]="isReadOnly"></app-decimal-input>

                    <small class="text-danger" *ngIf="hasError('amount', 'required')">
                      {{ 'validation.amount-required' | translate }}
                    </small>

                    <small class="text-danger" *ngIf="hasError('amount', 'min')">
                      {{ 'validation.amount-min' | translate }}
                    </small>
                  </div>

                  <div class="form-field currency-field">
                    <label>
                      {{ 'label.currency' | translate }}
                      <app-field-help [tooltip]="'help.currency' | translate"></app-field-help>
                    </label>

                    <div class="currency-combobox">
                      <button *ngIf="!isCurrencyDropdownOpen" type="button" class="form-control currency-combobox__closed" [disabled]="isReadOnly" (click)="openCurrencyDropdown()" aria-haspopup="listbox" aria-expanded="false" [attr.aria-label]="'label.currency' | translate">
                        <span *ngIf="selectedCurrency as currency" class="currency-combobox__closed-value">
                          <span class="currency-combobox__code">{{ currency.code }}</span>
                          <span class="currency-combobox__name">– {{ currency.name }}</span>
                        </span>
                        <span *ngIf="!selectedCurrency">{{ 'placeholder.choose-currency' | translate }}</span>
                      </button>

                      <input *ngIf="isCurrencyDropdownOpen" type="text" class="form-control currency-combobox__input" [value]="currencyFilterTerm" [readonly]="isReadOnly" [placeholder]="'placeholder.choose-currency' | translate" autocomplete="off" role="combobox" aria-autocomplete="list" aria-expanded="true" aria-controls="currency-listbox" [attr.aria-activedescendant]="activeCurrencyIndex >= 0 ? 'currency-option-' + activeCurrencyIndex : null" [attr.aria-label]="'label.currency' | translate" (input)="onCurrencySearch(($any($event.target).value))" (keydown)="onCurrencyKeydown($event)" (blur)="onCurrencyBlur()">

                      <div class="currency-combobox__menu" *ngIf="isCurrencyDropdownOpen && !isReadOnly" id="currency-listbox" role="listbox">
                        <button type="button" class="currency-combobox__option" *ngFor="let currency of filteredCurrencies; let i = index; trackBy: trackByCurrencyCode" [attr.id]="'currency-option-' + i" role="option" [attr.aria-selected]="i === activeCurrencyIndex" [class.currency-combobox__option--active]="i === activeCurrencyIndex" (mousedown)="$event.preventDefault()" (click)="selectCurrency(currency)">
                          <span class="currency-combobox__code">{{ currency.code }}</span>
                          <span class="currency-combobox__name">– {{ currency.name }}</span>
                        </button>

                        <div class="currency-combobox__empty" *ngIf="filteredCurrencies.length === 0">
                          {{ 'label.inga-traffar' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-field" *ngIf="!isPreRequest">
                    <label for="interestAmount">
                      {{ 'label.interest-amount' | translate }}
                      <app-field-help [tooltip]="'help.interest-amount' | translate"></app-field-help>
                    </label>
                    <app-decimal-input formControlName="interestAmount" inputId="interestAmount" [placeholder]="'placeholder.example-interest-amount' | translate" [readonly]="isReadOnly"></app-decimal-input>

                    <small class="text-danger" *ngIf="hasError('interestAmount', 'min')">
                      {{ 'validation.interest-amount-min' | translate }}
                    </small>
                  </div>

                  <div class="form-field" *ngIf="!isPreRequest">
                    <label for="interestComment">
                      {{ 'label.interest-comment' | translate }}
                      <app-field-help [tooltip]="'help.interest-comment' | translate"></app-field-help>
                    </label>
                    <input id="interestComment" type="text" class="form-control" formControlName="interestComment" [placeholder]="'placeholder.example-interest-comment' | translate" [readonly]="isReadOnly">

                    <small class="text-danger" *ngIf="hasError('interestComment', 'requiredWhenInterestAmountExists')">
                      {{ 'validation.interest-comment-required' | translate }}
                    </small>
                  </div>

                  <div class="form-field">
                    <label>
                      {{ 'label.preferential-right' | translate }}
                      <app-field-help [tooltip]="'help.preferential-right' | translate"></app-field-help>
                    </label>

                    <select class="form-control" formControlName="preferentialRightId" [disabled]="isReadOnly">
                      <option [ngValue]="null">{{ 'label.none' | translate }}</option>

                      <option *ngFor="let right of preferentialRights" [ngValue]="right.id">
                        {{ right.name }} ({{ right.description }})
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-field special-field mt-3">
                  <label for="reasonForClaim">
                    {{ (hasNonOprioriteredPreferentialRight ? 'label.reason-for-claim-with-preferential-right' : 'label.reason-for-claim') | translate }}
                    <app-field-help [tooltip]="'help.reason-for-claim' | translate"></app-field-help>
                  </label>
                  <textarea id="reasonForClaim" class="form-control" rows="3" formControlName="comment" [placeholder]="'placeholder.example-reason-for-claim' | translate" [readonly]="isReadOnly">
                  </textarea>

                  <small class="text-danger" *ngIf="hasError('comment', 'required')">
                    {{ 'validation.reason-for-claim-required' | translate }}
                  </small>
                </div>
              </div>

              <div class="form-section">
                <div class="section-title">
                  {{ 'label.contact-information' | translate }}
                </div>
                <div class="section-subtitle mb-3">
                  {{ 'label.section-description-contact' | translate }}
                </div>

                <div class="form-check mb-3">
                  <input type="checkbox" class="form-check-input" id="hasAgent" formControlName="hasAgent">
                  <label class="form-check-label" for="hasAgent">
                    {{ 'label.has-agent' | translate }}
                    <app-field-help [tooltip]="'help.has-agent' | translate"></app-field-help>
                  </label>
                </div>

                <div class="form-grid">
                  <ng-container formGroupName="contactInformation">
                    <div class="form-field">
                      <label for="coAddress">
                        {{ coAddressLabel }}
                        <app-field-help [tooltip]="'help.care-of' | translate"></app-field-help>
                      </label>
                      <input id="coAddress" class="form-control" formControlName="coAddress" [placeholder]="coAddressPlaceholder" [readonly]="isReadOnly">

                      <small class="text-danger" *ngIf="hasError('contactInformation.coAddress', 'required')">
                        {{ 'validation.co-address-required' | translate }}
                      </small>
                    </div>

                    <div class="form-field">
                      <label for="address1">
                        {{ 'label.address' | translate }}
                        <app-field-help [tooltip]="'help.address' | translate"></app-field-help>
                      </label>
                      <input id="address1" class="form-control" formControlName="address1" [placeholder]="'placeholder.example-address' | translate" [readonly]="isReadOnly">

                      <small class="text-danger" *ngIf="hasError('contactInformation.address1', 'required')">
                        {{ 'validation.field-required' | translate }}
                      </small>
                    </div>

                    <div class="form-field">
                      <label for="address2">
                        {{ 'label.address2' | translate }}
                        <app-field-help [tooltip]="'help.address2' | translate"></app-field-help>
                      </label>
                      <input id="address2" class="form-control" formControlName="address2" [placeholder]="'placeholder.example-address2' | translate" [readonly]="isReadOnly">
                    </div>

                    <div class="form-field">
                      <label for="zipCode">
                        {{ 'label.postnr' | translate }}
                        <app-field-help [tooltip]="'help.postnr' | translate"></app-field-help>
                      </label>
                      <input id="zipCode" class="form-control" formControlName="zipCode" [placeholder]="'placeholder.example-zip-code' | translate" [readonly]="isReadOnly">

                      <small class="text-danger" *ngIf="hasError('contactInformation.zipCode', 'required')">
                        {{ 'validation.field-required' | translate }}
                      </small>

                      <small class="text-danger" *ngIf="hasError('contactInformation.zipCode', 'maxlength')">
                        {{ 'validation.zip-code-max-length' | translate }}
                      </small>

                      <small class="text-danger" *ngIf="hasError('contactInformation.zipCode', 'pattern')">
                        {{ 'validation.zip-code-invalid-swedish' | translate }}
                      </small>
                    </div>

                    <div class="form-field">
                      <label for="city">
                        {{ 'label.postort' | translate }}
                        <app-field-help [tooltip]="'help.city' | translate"></app-field-help>
                      </label>
                      <input id="city" class="form-control" formControlName="city" [placeholder]="'placeholder.example-city' | translate" [readonly]="isReadOnly">

                      <small class="text-danger" *ngIf="hasError('contactInformation.city', 'required')">
                        {{ 'validation.field-required' | translate }}
                      </small>
                    </div>

                    <div class="form-field country-field">
                      <label>
                        {{ 'label.country' | translate }}
                        <app-field-help [tooltip]="'help.country' | translate"></app-field-help>
                      </label>

                      <div class="country-combobox">
                        <button *ngIf="!isCountryDropdownOpen" type="button" class="form-control country-combobox__closed" [disabled]="isReadOnly" (click)="openCountryDropdown()">

                          <span class="country-combobox__closed-value" *ngIf="selectedCountry as country">
                            <span [class]="getCountryFlagClass(country.code)" aria-hidden="true">
                            </span>

                            <span class="country-dropdown__name">{{ country.name }}</span>
                          </span>

                          <span *ngIf="!selectedCountry">{{ 'placeholder.choose-country' | translate }}</span>
                        </button>

                        <input *ngIf="isCountryDropdownOpen" type="text" class="form-control country-combobox__input" [value]="countryFilterTerm" [readonly]="isReadOnly" [placeholder]="'placeholder.choose-country' | translate" autocomplete="off" (input)="onCountrySearch(($any($event.target).value))" (keydown)="onCountryKeydown($event)" (blur)="onCountryBlur()">

                        <div class="country-combobox__menu" *ngIf="isCountryDropdownOpen && !isReadOnly">

                          <button type="button" class="country-combobox__option" *ngFor="let country of filteredCountries; let i = index; trackBy: trackByCountryCode" [class.country-combobox__option--active]="i === activeCountryIndex" (mousedown)="$event.preventDefault()" (click)="selectCountry(country)">

                            <span [class]="getCountryFlagClass(country.code)" aria-hidden="true">
                            </span>

                            <span class="country-dropdown__name">{{ country.name }}</span>
                          </button>

                          <div class="country-combobox__empty" *ngIf="filteredCountries.length === 0">
                            {{ 'label.inga-traffar' | translate }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <div class="form-field">
                    <label for="contactPersonFirstName">
                      {{ 'label.fornamn' | translate }}
                      <app-field-help [tooltip]="'help.fornamn' | translate"></app-field-help>
                    </label>
                    <input id="contactPersonFirstName" class="form-control" formControlName="contactPersonFirstName" [placeholder]="'placeholder.example-first-name' | translate" [readonly]="isReadOnly">
                  </div>

                  <div class="form-field">
                    <label for="contactPersonLastName">
                      {{ 'label.efternamn' | translate }}
                      <app-field-help [tooltip]="'help.efternamn' | translate"></app-field-help>
                    </label>
                    <input id="contactPersonLastName" class="form-control" formControlName="contactPersonLastName" [placeholder]="'placeholder.example-last-name' | translate" [readonly]="isReadOnly">
                  </div>

                  <ng-container formGroupName="contactInformation">
                    <div class="form-field">
                      <label for="contactEmail">
                        {{ 'label.epost' | translate }}
                        <app-field-help [tooltip]="'help.epost' | translate"></app-field-help>
                      </label>
                      <input id="contactEmail" class="form-control" formControlName="email" [placeholder]="'placeholder.example-email' | translate" [readonly]="isReadOnly">

                      <small class="text-danger" *ngIf="hasError('contactInformation.email', 'required')">
                        {{ 'validation.field-required' | translate }}
                      </small>

                      <small class="text-danger" *ngIf="hasError('contactInformation.email', 'email')">
                        {{ 'label.ogiltig-epost' | translate }}
                      </small>

                      <small class="text-danger" *ngIf="hasError('contactInformation.email', 'invalidTestDomain')">
                        {{ 'validation.email-test-domain-not-allowed' | translate }}
                      </small>

                      <small class="text-danger" *ngIf="hasError('contactInformation.email', 'trailingDot')">
                        {{ 'validation.email-trailing-dot' | translate }}
                      </small>
                    </div>

                    <div class="form-field">
                      <label for="contactPhone">
                        {{ 'label.telefonnr' | translate }}
                        <app-field-help [tooltip]="'help.telefon' | translate"></app-field-help>
                      </label>
                      <input id="contactPhone" type="tel" class="form-control" formControlName="phone" [placeholder]="'placeholder.example-phone' | translate" [readonly]="isReadOnly">

                      <small class="text-danger" *ngIf="hasError('contactInformation.phone', 'pattern')">
                        {{ 'label.ogiltigt-telefonnr' | translate }}
                      </small>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="form-section">
                <div class="section-title">
                  {{ 'label.payout-account' | translate }}
                </div>
                <div class="section-subtitle mb-3">
                  {{ 'label.section-description-payout-account' | translate }}
                </div>

                <div formGroupName="bankAccount" class="form-grid">
                  <div class="form-field">
                    <label>
                      {{ 'label.account-type' | translate }}
                      <app-field-help [tooltip]="'help.account-type' | translate"></app-field-help>
                    </label>

                    <select class="form-control" formControlName="accountType" [disabled]="isReadOnly">
                      <option *ngFor="let type of accountTypes" [ngValue]="type">
                        {{ type | accountTypeLabel }}
                      </option>
                    </select>
                  </div>

                  <div class="form-field">
                    <label for="accountHolder">
                      {{ 'label.account-holder' | translate }}
                      <app-field-help [tooltip]="'help.account-holder' | translate"></app-field-help>
                    </label>
                    <input id="accountHolder" class="form-control" formControlName="accountHolder" [placeholder]="'placeholder.example-account-holder' | translate" [readonly]="isReadOnly">

                    <small class="text-danger" *ngIf="hasError('bankAccount.accountHolder', 'required')">
                      {{ 'validation.account-holder-required' | translate }}
                    </small>
                  </div>

                  <div class="form-field" *ngIf="isSwedishAccountType">
                    <label for="clearing">{{ 'label.clearing' | translate }}</label>
                    <input id="clearing" class="form-control" formControlName="clearing" [placeholder]="'placeholder.example-clearing' | translate" (blur)="onClearingBlur()" [readonly]="isReadOnly">

                    <small class="text-danger" *ngIf="hasError('bankAccount.clearing', 'required')">
                      {{ 'validation.clearing-required' | translate }}
                    </small>

                    <small
                      class="text-danger"
                      *ngIf="shouldShowClearingFeedback() && hasError('bankAccount.clearing', 'invalidClearing')">
                      {{ getClearingValidationMessage() }}
                    </small>
                  </div>

                  <div class="form-field" *ngIf="isSwedishAccountType || isPlusgiroAccountType || isBankgiroAccountType || isOtherInternationalAccountType">
                    <label for="accountNumber">
                      {{ accountNumberLabel }}
                      <app-field-help *ngIf="isPlusgiroAccountType" [tooltip]="'help.plusgiro-number' | translate"></app-field-help>
                      <app-field-help *ngIf="isBankgiroAccountType" [tooltip]="'help.bankgiro-number' | translate"></app-field-help>
                      <app-field-help *ngIf="isSwedishAccountType" [tooltip]="'help.kontonr' | translate"></app-field-help>
                      <app-field-help *ngIf="isOtherInternationalAccountType" [tooltip]="'help.international-account-number' | translate"></app-field-help>
                    </label>
                    <input id="accountNumber" class="form-control" formControlName="accountNumber" [placeholder]="accountNumberPlaceholder" (blur)="onAccountNumberBlur()" [readonly]="isReadOnly">

                    <small class="text-danger" *ngIf="hasError('bankAccount.accountNumber', 'required')">
                      {{ 'validation.account-number-required' | translate }}
                    </small>

                    <small class="text-danger" *ngIf="
                        shouldShowAccountNumberFeedback() &&
                        (
                          hasError('bankAccount.accountNumber', 'invalidAccountNumber') ||
                          hasError('bankAccount.accountNumber', 'invalidSwedishBankAccount') ||
                          hasError('bankAccount.accountNumber', 'invalidPlusgiro') ||
                          hasError('bankAccount.accountNumber', 'invalidBankgiro')
                        )
                      ">
                      {{ getAccountNumberValidationMessage() }}
                    </small>
                  </div>

                  <div class="form-field" *ngIf="isSwedishAccountType">
                    <label for="bankName">
                      {{ 'label.bank' | translate }}
                      <app-field-help [tooltip]="'help.bank' | translate"></app-field-help>
                    </label>
                    <input id="bankName" class="form-control" formControlName="bankName" [placeholder]="'placeholder.example-bank-name' | translate" [readonly]="isReadOnly">

                    <small class="text-danger" *ngIf="hasError('bankAccount.bankName', 'required')">
                      {{ 'validation.bank-name-required' | translate }}
                    </small>

                    <small class="validation-message" *ngIf="hasError('bankAccount.bankName', 'bankNameMismatch')">
                      {{ getBankNameMismatchMessage() }}
                    </small>
                  </div>

                  <div class="form-field" *ngIf="isIbanAccountType">
                    <label for="iban">
                      {{ 'label.iban-short' | translate }}
                      <app-field-help [tooltip]="'help.iban' | translate"></app-field-help>
                    </label>
                    <input id="iban" class="form-control" formControlName="iban" [placeholder]="'placeholder.example-iban' | translate" (blur)="onIbanBlur()" [readonly]="isReadOnly">

                    <small class="text-danger" *ngIf="hasError('bankAccount.iban', 'required')">
                      {{ 'validation.iban-required' | translate }}
                    </small>

                    <small class="text-danger" *ngIf="shouldShowIbanFeedback() && hasError('bankAccount.iban', 'invalidIban')">
                      {{ getIbanValidationMessage() }}
                    </small>
                  </div>

                  <div class="form-field" *ngIf="isIbanAccountType || isOtherInternationalAccountType">
                    <label for="bic">
                      {{ 'label.bic-short' | translate }}
                      <app-field-help [tooltip]="'help.bic' | translate"></app-field-help>
                    </label>
                    <input id="bic" class="form-control" formControlName="bic" [placeholder]="'placeholder.example-bic' | translate" (blur)="onBicBlur()" [readonly]="isReadOnly">

                    <small class="text-danger" *ngIf="hasError('bankAccount.bic', 'required')">
                      {{ 'validation.bic-required' | translate }}
                    </small>

                    <small class="text-danger" *ngIf="shouldShowBicFeedback() && hasError('bankAccount.bic', 'invalidBic')">
                      {{ getBicValidationMessage() }}
                    </small>

                    <small class="text-danger" *ngIf="shouldShowBicFeedback() && hasError('bankAccount.bic', 'bicCountryMismatch')">
                      {{ getBicCountryMismatchMessage() }}
                    </small>
                  </div>

                  <div class="form-field">
                    <label for="referenceText">
                      {{ 'label.reference-text' | translate }}
                      <app-field-help [tooltip]="'help.reference-text' | translate"></app-field-help>
                    </label>
                    <input id="referenceText" class="form-control" formControlName="comment" [placeholder]="'placeholder.example-reference-text' | translate" [readonly]="isReadOnly">

                    <small class="text-danger" *ngIf="hasError('bankAccount.comment', 'required')">
                      {{ 'validation.ocr-required' | translate }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="form-section attachment-section">
                <div class="section-title">
                  {{ 'label.attached-files' | translate }}
                </div>

                <div *ngIf="isCreateFromPreRequestMode" class="section-subtitle">
                  {{ 'texts.create-from-claim-hint' | translate }}
                </div>

                <file-upload
                  [readOnly]="isReadOnly"
                  [existingFiles]="existingFiles">
                </file-upload>

                <small class="text-danger" *ngIf="noFilesErrorShown">
                  {{ 'validation.underlag-required' | translate }}
                </small>
              </div>

              <div class="form-actions mt-4">
                <div *ngIf="debtorIdentityMissing" class="process-banner process-banner--danger">
                  <div class="process-banner__title">{{ 'error.load-error-title' | translate }}</div>
                  <div class="process-banner__text">{{ 'error.debtor-identity-unavailable' | translate }}</div>
                </div>

                <div *ngIf="noFilesWarningShown" class="process-banner process-banner--warning">
                  <div class="process-banner__title">{{ 'texts.no-files-warning-title' | translate }}</div>
                  <div class="process-banner__text">{{ 'texts.no-files-warning' | translate }}</div>
                  <div class="mt-3">
                    <button type="button" class="btn-garanti btn-warning" (click)="saveWithoutFiles()">
                      {{ 'button.save-anyway' | translate }}
                    </button>
                  </div>
                </div>

                <button type="button" class="btn-garanti btn-blue" *ngIf="!isReadOnly && !noFilesWarningShown && !debtorIdentityMissing" (click)="save()">
                  {{ 'button.save-and-send' | translate }}
                </button>
              </div>
            </form>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="col-xl-1"></div>
  </div>
</div>
